import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
  // TODO well delete when back will be ready
  // isUserAuthentication: false,
  isUserAuthentication: true,
};

const auth = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setUserAuthentication: (state, { payload }: PayloadAction<boolean>) => {
      state.isUserAuthentication = payload;
    },
  },
});

export const { setUserAuthentication } = auth.actions;

export default auth;
